import { AfterViewInit, ChangeDetectorRef, Directive, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appSetHeight]'
})
export class SetHeightDirective implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  constructor(private elementRef: ElementRef, private changeDetectorRef: ChangeDetectorRef) {}

  @Input() percent: number = 100;
  @Input() padding: number = 20;
  @Input() overflow: string = "auto";

  ngOnInit(): void {
    this.setHeightToRemainingScreenHeight(this.elementRef);
    let item = this;
    window.addEventListener('resize', function() {item.setHeightToRemainingScreenHeight(item.elementRef) });
  }

  ngOnDestroy(): void {
    let item = this;
    window.removeEventListener('resize', function() {item.setHeightToRemainingScreenHeight(item.elementRef) });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['elementRef']) {
      if (this.elementRef.nativeElement) {
        this.setHeightToRemainingScreenHeight(this.elementRef);
      }
    }
  }

  ngAfterViewInit() {
    var ref = this;
    setTimeout(function() {
      ref.setHeightToRemainingScreenHeight(ref.elementRef);
    }, 1)
    
  }

  private setHeightToRemainingScreenHeight(elementItem: ElementRef): void {
    const viewportHeight = window.innerHeight;
    const element = elementItem.nativeElement;

    const totalHeight = viewportHeight - element.getBoundingClientRect().top - this.padding;
    const elementHeight = totalHeight * (this.percent / 100)

    element.style.overflow = this.overflow;
    element.style.height = `${elementHeight}px`;
  }
}